import { Icon, type IconProps } from './Icon';

export function TerminalIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="m4 17 6-5-6-5" />
      <path d="M12 19h8" />
    </Icon>
  );
}
